import { GetterTree } from 'vuex';
import { Store } from '@/store/types';
import { BreadcrumbState } from '../types';

export const breadcrumbGetters: GetterTree<BreadcrumbState, Store> = {
};
